import React from "react";
import "./App.css";
import { Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import Layout from "./components/Layout";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Products from "./pages/Products";
import Certification from "./pages/Certification";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Temperature from "./pages/Temperature";
import Cones from "./pages/Cones";
import Gasflow from "./pages/Gasflow";
import DashboardLayout from "./components/DashboardLayout";
import Generate from "./pages/Generate";

const App = () => {
  const user = localStorage.getItem("user");
  const userId = JSON.parse(user);
  return (
    <>
      <Routes>
        {userId == null ? (
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="about-us" element={<About />} />
            <Route path="contact-us" element={<Contact />} />
            <Route path="products" element={<Products />} />
            <Route path="certification" element={<Certification />} />
            {userId == null && <Route path="login" element={<Login />} />}
          </Route>
        ) : (
          <Route path="/" element={<DashboardLayout />}>
            <Route index element={<Dashboard />} />
            <Route path="temperature" element={<Temperature />} />
            <Route path="cones-count" element={<Cones />} />
            <Route path="gas-flow" element={<Gasflow />} />
            <Route path="generate" element={<Generate />} />
          </Route>
        )}
      </Routes>
    </>
  );
};

export default App;
